import { NoxusLoadingPulse } from "./NoxusLoadingPulse";
import { cn } from "@/lib/utils";

export const NoxusLoadingScreen = ({
  isFullScreen = true,
}: {
  isFullScreen?: boolean;
}) => {
  return (
    <div
      className={cn(
        "flex flex-1 justify-center items-center relative",
        isFullScreen ? "fixed inset-0 z-50 bg-background" : "h-full w-full"
      )}
    >
      <NoxusLoadingPulse size={50} />
      <div className="absolute bottom-12">
        <img
          src={
            "https://storage.googleapis.com/image-storage-spot-manual/app/noxus.svg"
          }
          alt={"Noxus logo"}
          width={75}
          height={16}
          className="dark:invert dark:brightness-0"
        />
      </div>
    </div>
  );
};
